import { observer } from 'mobx-react'
import React, { Fragment, Component } from 'react'

import QueryRunnerStore from './QueryRunnerStore'
import Panel from '../../../../UniformComponents/Panel'
import Select from '../../../form/Select'
import Input from '../../../form/Input'
import Checkbox from '../../../form/Checkbox'

import './queryRunner.scss'
import Button from '../../../../UniformComponents/Button'
import LinkButton from '../../../../UniformComponents/LinkButton'

@observer
class QueryRunner extends Component {
    constructor(props) {
        super(props)

        this.queryRunnerStore = new QueryRunnerStore(props.store)

        this.state = {
            schema: 'explori_v3',
            schemas: [],
            tables: [],
            cols: [],
        }
    }

    componentDidMount() {
        const { store } = this.props
        store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'queryRunner',
                url: '/intranet/queryrunner',
                title: 'Query Runner',
            },
        ]

        this.queryRunnerStore.init()
    }

    renderParams = () => {
        const { queryRunnerStore } = this
        const { queryParams, changeParam } = queryRunnerStore

        return (
            <div className="params">
                <h3>Parameters</h3>
                <div>
                    {queryParams.map(({ key, value, label, type }) => (
                        <div>
                            {type === 'checkbox'
                                ? (
                                    <Checkbox
                                        name={key || value}
                                        label={label}
                                        className="exploriNativeCheckbox"
                                        onBlur={changeParam}
                                    />
                                ) : (
                                    <Input
                                        label={label}
                                        name={key || value}
                                        onBlur={changeParam}
                                    />
                                )
                            }
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    renderResponse = () => {
        const { queryRunnerStore } = this
        const { response, formParams } = queryRunnerStore
        let className = 'response'
        className += (queryRunnerStore.error)
            ? ' error'
            : ' success'

        if (!response) return null

        const elem = (formParams.download)
            ? (
                <LinkButton
                    isExternal
                    target="_blank"
                    cssClass="tableButton"
                    label="Download CSV"
                    icon="far fa-arrow-right"
                    href={response}
                    onClick={(e) => {
                        e.stopPropagation()
                    }}
                />
            ) : response

        return (
            <div className={className}>
                {elem}
            </div>
        )
    }

    render() {
        const { queryRunnerStore } = this

        return (
            <Fragment>
                {!queryRunnerStore.loading && (
                    <Panel cssClass="queryRunner">
                        <div>
                            <Select
                                style={{ padding: '10px 0px' }}
                                placeholder="Please select a query to run..."
                                options={queryRunnerStore.customQueries}
                                onBlur={queryRunnerStore.changeQuery}
                            />
                        </div>
                        {queryRunnerStore.showDetails && (
                            <Fragment>
                                <div className="description">
                                    {queryRunnerStore.description}
                                </div>
                                <div>
                                    {this.renderParams()}
                                </div>
                                <div>
                                    <Button
                                        label="Run"
                                        cssClass="regular primary"
                                        onClick={queryRunnerStore.run}
                                    />
                                </div>
                                {this.renderResponse()}
                            </Fragment>
                        )}
                    </Panel>
                )}
            </Fragment>
        )
    }
}

export default QueryRunner
